module.exports = __webpack_public_path__ + "static/media/gts30.7d6cfa09.png";